import { useEffect, useState } from 'react';
import type { ServiceCode } from '../../../../common/enums/serviceCode';
import type { IRequest } from '../../interfaces/request';
import { ToastType } from '../../../../common/enums/toastType';
import { fetchJson, getJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { showServiceToast } from '../../../utils/showToast';
import { ReloadEpisode } from '../../pages/episodes/reloadEpisode';
import { ChangeToServiceModal } from '../ChangeToServiceModal';
import { Button } from '../common';

interface IChangeServiceButtonButtonProps {
    reloadProcess: (mode: ReloadEpisode) => Promise<void>;
    request: IRequest;
    saveDiagnosticReport: () => Promise<void>;
}

interface IService {
    code: ServiceCode;
    id: string;
    name: string;
}

export function ChangeServiceButton(props: IChangeServiceButtonButtonProps) {
    const [services, setServices] = useState<IService[]>([]);
    const [showModal, setShowModal] = useState(false);

    async function loadServices() {
        const result = await getJson(`/api/requests/${props.request.id}/myServiceChangeList`);
        if (result.json.items.length) {
            setServices(result.json.items);
        }
    }

    useEffect(() => {
        loadServices();
    }, [props.request.serviceId]);

    if (services.length === 0) {
        return null;
    }

    async function changeService(serviceId: string) {
        setShowModal(false);

        await props.saveDiagnosticReport();

        await fetchJson('/api/requestServiceChange', 'POST', { requestId: props.request.id, serviceId });

        const service = services.find((item) => item.id === serviceId);
        if (service) {
            showServiceToast(
                ToastType.success,
                'toast.consultTypeChanged',
                service,
                'processWizard',
                translateKey('toast.changesSaveSuccess')
            );
        }

        props.reloadProcess(ReloadEpisode.reloadSelf);
    }

    return (
        <>
            <ChangeToServiceModal
                closeModal={() => setShowModal(false)}
                isOpen={showModal}
                onChangeService={async (serviceId) => await changeService(serviceId)}
                services={services}
            />
            <Button
                automation="convertToConsult"
                color="secondary"
                large
                onClick={async () => setShowModal(true)}
                outlined
            >
                {translateKey('request.changeConsultType')}
            </Button>
        </>
    );
}
